import { createAsyncThunk } from '@reduxjs/toolkit';

import { apiSahClients, apiSahExternalContributions } from '~constants/api';

import { get, post, put, remove, upload } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'sah-external-contributions';

type FileUploadParams = {
  file: File;
  setProgress?: (value: number) => void;
};

const config = [
  { actionType: 'getGrouped', apiPath: `${apiSahExternalContributions}`, method: get },
  {
    actionType: 'getAll',
    apiPath: (params: Params) => `${apiSahClients}/${params.client_id}/external/contributions`,
    method: get,
  },
  { actionType: 'create', apiPath: apiSahExternalContributions, method: post },
  { actionType: 'update', apiPath: (params: Params) => `${apiSahExternalContributions}/${params.id}`, method: put },
  {
    actionType: 'deleteOne',
    apiPath: (params: Params) => `${apiSahExternalContributions}/${params.id}`,
    method: remove,
  },
];

export const uploadFile = createAsyncThunk(
  `sah-external-contributions-upload/upload`,
  async ({ file, setProgress }: FileUploadParams, { rejectWithValue }) => {
    try {
      return await upload(
        `${apiSahExternalContributions}/upload`,
        file,
        (progress) => {
          if (typeof progress === 'number') {
            setProgress?.(progress);
          }
        },
        undefined,
        undefined,
        true,
      );
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);

export const { getGrouped, getAll, deleteOne, create, update } = createThunks(typePrefix, config);
